import {
  BrowserRouter as Router,
  Routes,
  Route,
  Outlet,
  Navigate,
} from "react-router-dom";
import { useSelector } from "react-redux";
import { Suspense } from "react";
import FullPageLoading from "./components/FullPageLoading/FullPageLoading";
import AuthPage from "./containers/Authpage/Authpage";
import ChangePassword from "./containers/ChangePassword/ChangePassword"; // Import your ChangePassword component
import Layout from "./hocs/Layout";
import DashBoard from "./containers/Dashboard/Dashboard";
import TenantListing from "./containers/TenantListing/TenantListing";
import PlansListing from "./containers/PlansListing/PlansListing";
import CreatePlan from "./containers/CreatePlan/CreatePlan";
import ApplicationListing from "./containers/ApplicationListing/ApplicationListing";
import FeatureListing from "./containers/FeatureListing/FeatureListing";
import NotFound from "./containers/NotFound/NotFound";
import RolePermission from "./containers/RolePermissions/RolePermission";
import ModulePermission from "./containers/ModulePermission/ModulePermission";
import ModuleListing from "./containers/ModuleListing/ModuleListing";
import RoleListing from "./containers/RoleListing/RoleListing";
import FeatureCategoryTree from "./containers/FeatureCategoryTree/FeatureCategoryTree";
import StoreType from "./containers/StoreTypes/StoreType";
import PrivateRoute from "./components/PrivateRoute/PrivateRoute";
import TenantDetails from "./containers/TenantDetails/TenantDetails";
import { Toaster } from "react-hot-toast";
import UsersListing from "./containers/UsersListing/UsersListing";
import CreateUpdateKnowledgeCenter from "./components/CreateUpdateKnowledgeCenter/CreateUpdateKnowledgeCenter";
import KnowledgeCenter from "./containers/KnowledgeCenter/KnowledgeCenter";
import OnBoardTenant from "./containers/OnBoardTenant/OnBoardTenant";
import Settings from "./containers/Settings/Settings";

function App() {
  const { authData } = useSelector((state) => state.loginSlice);
  const PrivateRoutes = () => {
    if (!authData) {
      return <Navigate to="/login" replace />;
    }

    return (
      <Layout>
        <Outlet />
      </Layout>
    );
  };
  return (
    <>
      <Toaster position="top-center" reverseOrder={false} />
      <Router>
        <Suspense fallback={<FullPageLoading />}>
          <Routes>
            <Route path="/changepassword" element={<ChangePassword />} />
            <Route path="/login" element={<AuthPage />} />

            <Route path="*" element={<NotFound />} />
            <Route element={<PrivateRoutes />}>
              <Route path="/" exact element={<DashBoard />} />
              <Route path="/dashboard" exact element={<DashBoard />} />
              <Route
                path="/merchants"
                exact
                element={<TenantListing type={"activeMerchants"} />}
              />
              {/* <Route
                path="/uninstalledmerchants"
                exact
                element={<TenantListing type={"uninstalledShopifyMerchants"} />}
              /> */}
              <Route path="/users" exact element={<UsersListing />} />
              <Route path="/tenant/:id" exact element={<TenantDetails />} />
              <Route path="/tenant/create" element={<OnBoardTenant />} />

              {/*  <Route path="/plan" exact element={<PlansListing />} />
              <Route path="/plan/:id" exact element={<CreatePlan />} /> */}
              <Route
                path="/application"
                exact
                element={<ApplicationListing />}
              />
              {/* <Route path="/features" exact element={<FeatureListing />} />
              <Route path="/plan/create" element={<CreatePlan />} /> */}
              <Route path="/role/:id" element={<RolePermission />} />
              <Route path="/module/:id" element={<ModulePermission />} />
              <Route path="/module" element={<ModuleListing />} />
              <Route path="/role" element={<RoleListing />} />
              <Route path="/role/create" element={<RolePermission />} />
              <Route path="/settings" element={<Settings />} />
               

              {/* <Route
                path="/featureCategory"
                element={<FeatureCategoryTree />}
              />
              <Route path="/storeType" element={<StoreType />} />
              <Route
                path="/knowledge-center/:id"
                exact
                element={<CreateUpdateKnowledgeCenter />}
              />
              <Route
                path="/knowledge-center/create"
                element={<CreateUpdateKnowledgeCenter />}
              />
              <Route
                path="/knowledgecenter"
                exact
                element={<KnowledgeCenter />}
              /> */}
            </Route>
          </Routes>
        </Suspense>
      </Router>
    </>
  );
}

export default App;
